import { useCallback } from "react";

import { buildTracesSearchParams } from "@/components/TracesSearch/buildTracesSearchParams";
import { useResetPageOnStructuredSearch } from "@/components/StructuredSearch/hooks/useResetPageOnStructuredSearch";
import { useStructuredSearchStore } from "@/components/StructuredSearch";

export const useResetTracesPageOnStructuredSearch = () => {
  const structuredSearchStore = useStructuredSearchStore();
  const getSearchSnapshot = useCallback(
    () => buildTracesSearchParams(structuredSearchStore),
    [structuredSearchStore],
  );

  useResetPageOnStructuredSearch(getSearchSnapshot);
};
